import { QUERY_KEY } from 'constants/globalConstants'
import DashboardService from 'apiService/dashboardService'
import { useQuery } from 'react-query'

const useClientPercentageUptime = (order) => {
    return useQuery(QUERY_KEY.GET_CLIENT_PERCENTAGE_UPTIME, () => DashboardService.getUptimePercentage(order), {retry: false})
}

export default useClientPercentageUptime